import { isNull, isUndefined, omitBy } from 'lodash-es';

export const omitEmpty = <T extends object>(obj: T): Partial<T> => {
  return omitBy(obj, val => isNull(val) || isUndefined(val));
};
